import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectAllocatedResourcesBudgetRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditProjectAllocatedResourcesBudgetRequestPending({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditProjectAllocatedResourcesBudgetRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
